import { useStore } from "../store/state.js";
import { audio } from "./engine.js";
import type { Cue } from "./score.js";

export function victoryCue(cosmeticId: string | null | undefined): Cue {
  return cosmeticId === "cos.stinger.fanfare" ? "stinger.fanfare" : cosmeticId === "cos.stinger.drums" ? "stinger.drums" : "victory";
}

/** Shares the equipped server slot with the actual sound-preview button. */
export function playBattleOutcome(won: boolean): void {
  const stinger = useStore.getState().cosmetics?.find((c) => c.kind === "stinger" && c.equipped);
  audio.play(won ? victoryCue(stinger?.id) : "defeat");
}
